// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Introduction_wrapper__2xpqW","title":"Introduction_title__sy_Yr","content":"Introduction_content__1r3Di","blob":"Introduction_blob__16fBU"};